<template>
  <div class="hero-container conteudo_mov" ref="heroContainer">
    <div 
      class="hero-background" 
      :style="backgroundStyle"
    ></div>
    
    <!-- div class="hero-content conteudo_mov2 border-log left">
      <h1 class="cor-azul">Drink the air</h1>
      <p class="hero-description amarelo">
        We can’t take credit for our product — the water takes centuries to filter through the roots and is released into the air by the trees' leaves. Only then is it collected in our beautifully crafted glass bottles.
        <br><br>
        It’s not just hydration; AWA invites you to pause — a moment of connection with the earth that sustains us. The finest water for the finest moments.
        <br><br>
        AWA is a low-mineral, still artesian water sourced from the pristine air of the Amazon rainforest. With a very low TDS composition of 21 mg/l and a balanced pH of 7.1, AWA is perfect for enhancing the flavor of sophisticated foods and drinks.
      </p>
      <button 
        class="hero-button" 
        @click="$emit('button-click')"
      >
        {{ buttonText }}
      </button>
    </div -->
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import bgImage from '@/assets/bg01.jpg'

export default {
  name: 'HeroZoomBackground',
  emits: ['button-click'],
  setup() {
    const heroContainer = ref(null)
    const isVisible = ref(false)
    const animationId = ref(null)
    const animationDuration = 3000 // 3 segundos
    const startTime = ref(null)

    const backgroundStyle = ref({
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      transform: 'scale(1.1)',
      opacity: 0
    })

    const easeInOutQuad = (t) => {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2
    }

    const startAnimation = () => {
      if (animationId.value) return
      
      startTime.value = null
      backgroundStyle.value.opacity = 1
      backgroundStyle.value.transition = 'opacity 0.3s ease-out'
      
      const animate = (timestamp) => {
        if (!startTime.value) startTime.value = timestamp
        const elapsed = timestamp - startTime.value
        const progress = Math.min(elapsed / animationDuration, 1)
        const easedProgress = easeInOutQuad(progress)
        
        const currentScale = 1.1 - (0.1 * easedProgress)
        backgroundStyle.value.transform = `scale(${currentScale})`
        
        if (progress < 1) {
          animationId.value = requestAnimationFrame(animate)
        } else {
          animationId.value = null
        }
      }
      
      animationId.value = requestAnimationFrame(animate)
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isVisible.value) {
          isVisible.value = true
          startAnimation()
        }
      })
    }, {
      threshold: 0.1
    })

    onMounted(() => {
      if (heroContainer.value) {
        observer.observe(heroContainer.value)
      }
    })

    onUnmounted(() => {
      if (heroContainer.value) {
        observer.unobserve(heroContainer.value)
      }
      if (animationId.value) {
        cancelAnimationFrame(animationId.value)
      }
    })

    return {
      heroContainer,
      backgroundStyle
    }
  }
}
</script>

<style scoped>
:root {
  --cream: #E0D0A6;
  --blue: #6FD0E7;
  --green: #536D3F;
  --mid-green: #475C37;
  --dark-green: #3D4D31;
  --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
}

.border-log {
  border: 2px solid rgb(0, 0, 255);
}

.p-4 { padding: 1.5rem; }

.left {
  text-align: left;
}

.conteudo_mov {
  display: flex;
  width: 100%;
}

.conteudo_mov2 {
  max-width: 172rem;
  transition: max-width 0.3s ease-in-out;
  text-align: left;
  flex-grow: 1;
  padding: 8rem;
}

.hero-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  will-change: transform, opacity;
  transform-origin: center center;
  z-index: 0;
  transition: transform 3s cubic-bezier(0.33, 1, 0.68, 1);
}

.hero-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Alinha o conteúdo no topo */
  align-items: flex-start;     /* Alinha à esquerda */
  text-align: left;
  max-width: 40%;  /* Limita a largura a 40% da tela */
}

h1 {
  font-family: var(--object-sans);
  font-size: 6rem;
  font-weight: 400;
  color: var(--blue);
}

.hero-description {
  font-family: var(--object-sans);
  color: var(--cream);
  font-size: 2rem;
  letter-spacing: 0.06rem;
  line-height: 3.4rem;
}

.hero-button {
  padding: 12px 30px;
  font-size: 1.1rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid white;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}

.hero-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Responsividade para mobile */
@media (max-width: 768px) {
  h1 {
    font-size: 4rem;
  }

  .hero-description {
    font-size: 2.0rem;
    letter-spacing: 0.04rem;
    line-height: 2.4rem;
  }

  .hero-button {
    padding: 10px 25px;
    font-size: 1rem;
  }
}
</style>
